<template>
    <div class="company">
        <v-dialog content-class="white" persistent v-model="progressLoad" max-width="80px">
            <v-progress-circular :size="50" indeterminate color="blue"></v-progress-circular>
        </v-dialog>
        <Header :hideDrower=true />
        <TopSection :hideSearch=true :heading="`${$route.params.id ? 'Edit' : 'Add'} Company`" user="J K" />
        <v-dialog persistent v-model="success" max-width="522px">
            <div class="notification-heading standard-height blue pr-4">
                <a href="/" title="Close" class="close-notification">
                    <v-icon class="white body-2 blue--text notification-close mr-1">close</v-icon>
                </a>
            </div>
            <div class="notification-content white">
                <span class="primary--text font-weight-bold">Company successfully {{ companyId ? deleted ? 'deleted' : 'edited' : 'created'}}</span>
            </div>
        </v-dialog>
        <v-dialog persistent v-model="errorDialog" max-width="522px">
            <div class="notification-heading standard-height blue pr-4">
                <a href="/" title="Close" class="close-notification">
                    <v-icon class="white body-2 blue--text notification-close mr-1">close</v-icon>
                </a>
            </div>
            <div class="notification-content white">
                <span class="primary--text font-weight-bold">An error has occurred.</span>
            </div>
        </v-dialog>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-container class="pt-3" grid-list-lg>
                <v-layout>
                    <v-flex xs12 md8 xl5>
                        <div class="form-section">
                            <v-layout row wrap>
                                <v-flex md12>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Company name</span>
                                    </div>
                                    <v-text-field
                                        v-model="name"
                                        :readonly="userType == 2"
                                        v-validate="'required'"
                                        data-vv-name="name"
                                        :error-messages="errors.collect('name')"
                                        solo
                                        flat
                                        :counter="250"
                                        height=66
                                        maxlength=250
                                        placeholder="Company Name"
                                        :class="`mb-1 ${userType == 2 ? ' disabled' : ''}`">
                                    </v-text-field>
                                </v-flex>
                            </v-layout>

                        </div>
                        <div class="form-section mt-3">
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md5 class="logo-upload-flexbox">
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Logo</span>
                                    </div>
                                    <div class="white file-uploader-wrapper content-section px-4">
                                        <div :class="`file-uploader logo ${imgPreviewSrc.logo !== ''? 'uploaded' : ''}`">
                                            <input
                                                id="image-logo"
                                                ref="logo"
                                                model="logoFile"
                                                type="file"
                                                @change="handleFileSelection($event, 'logo', 'logoFile')"
                                                data-vv-name="logoFile" v-validate="'image'"/>
                                            <span class="subheading font-weight-bold black--text text--lighten-1">Logo</span>
                                            <div class="image-preview-wrapper" :style="{ backgroundImage: 'url(' + imgPreviewSrc.logo + ')' }">
                                            </div>
                                            <v-btn fab small :class="`relative ma-0 ${imgPreviewSrc.logo == '' && 'hide'}`" @click="handleRemoveFile('logo')">
                                                <v-icon>close</v-icon>
                                            </v-btn>
                                    
                                        </div>
                                        <div :class="`file-uploader-bottom pl-4`">
                                            <span class="font-italic grey--text text--lighten-2 pl-3">{{ filename.logo }}</span>
                                            <button class="cc__box-shadow square-button upload-button" type="button" @click="uploadFile('logo')">
                                                <v-icon color="black">cloud_upload</v-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="v-text-field__details pl-4 ml-3">
                                        <div class="v-messages theme--light error--text">
                                            <div class="v-messages__wrapper">
                                                <div class="v-messages__message message-transition-enter-to">{{ errors.first('logoFile') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </v-flex>
                                <v-flex xs12 sm6 md7>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Home Screen Background</span>
                                    </div>
                                    <div class="white file-uploader-wrapper content-section px-4">

                                        <div :class="`file-uploader background ${imgPreviewSrc.background !== ''? 'uploaded' : ''}`">
                                            <input
                                                id="image-background"
                                                ref="background"
                                                type="file"
                                                @change="handleFileSelection($event, 'background', 'backgroundFile')"
                                                data-vv-name="backgroundFile"
                                                v-validate="'image'"/>
                                            <span class="subheading font-weight-bold black--text text--lighten-1">Background</span>
                                            <div class="image-preview-wrapper">
                                                <img class="image-preview" :src="`${imgPreviewSrc.background}`" alt="Upload preview" />
                                            </div>
                                            <v-btn fab small :class="`relative ma-0 ${imgPreviewSrc.background == '' && 'hide'}`" @click="handleRemoveFile('background')">
                                                <v-icon>close</v-icon>
                                            </v-btn>
                                        </div>
                                        <div :class="`file-uploader-bottom pl-4`">
                                            <span class="font-italic grey--text text--lighten-2 pl-3">{{ filename.background }}</span>
                                            <button class="cc__box-shadow square-button upload-button" type="button" @click="uploadFile('background')">
                                                <v-icon color="black">cloud_upload</v-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="v-text-field__details pl-4 ml-3">
                                        <div class="v-messages theme--light error--text">
                                            <div class="v-messages__wrapper">
                                                <div class="v-messages__message message-transition-enter-to">{{ errors.first('backgroundFile') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </div>
                        <div class="form-section mt-4 pt-2">
                            <v-layout row wrap class="pt-1">
                                <v-flex xs12 sm6 md5>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Accent Colour</span>
                                    </div>
                                    <div class="white content-section py-2 pr-2 pl-4 color-selector relative">
                                        <span class="primary--text pl-3">{{ color.hex }} </span>
                                        <div @click="showColorPicker = !showColorPicker" :v-model="color" v-bind:style="{background: color.hex}" right class="color-preview"></div>
                                        <div :v-model="showColorPicker" :class="`color-range relative ${showColorPicker ? '' : 'hide'}`">
                                            <sketch-picker v-model="color"></sketch-picker>
                                        </div>
                                    </div>
                                    <v-btn :class="`full-width relative ma-0 ${showColorPicker ? '' : 'hide'}`" @click="closeColerPicker()">
                                        <span>Save colour and exit</span>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12 sm6 md7>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Theme</span>
                                    </div>
                                    <v-select height=66
                                        background-color="white"
                                        color="primary"
                                        :items="items"
                                        v-model="selectedTheme"
                                        append-icon="keyboard_arrow_down"
                                        :hide-details="true"
                                        solo></v-select>
                                </v-flex>
                            </v-layout>
                        </div>

                        <div class="form-section mt-4 pt-2">
                            <v-layout row wrap class="pt-1">
                                <v-flex xs12 sm6 md5>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Automatic Logout</span>
                                    </div>
                                    <div class="standard-height white relative pl-4">
                                        <vue-numeric-input
                                            placeholder="minutes"
                                            v-model="clientTimeoutMinutes"
                                            controls-type="updown"
                                            :min=0
                                            :max=10000
                                            :counter="10000">
                                        </vue-numeric-input>
                                    </div>
                                </v-flex>

                                <v-flex xs12 sm6 md7>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Sharing outside company</span>
                                    </div>
                                    <v-select height=66
                                        background-color="white"
                                        color="primary"
                                        :items="sharingOptionsItems"
                                        v-model="sharingOptionsItems[0]"
                                        append-icon="keyboard_arrow_down"
                                        :hide-details="true"
                                        :disabled="true"
                                        solo></v-select>
                                </v-flex>
                                <v-flex xs12 sm6 md5>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Image Size Limit (MB)</span>
                                    </div>
                                    <div class="standard-height white relative pl-4">
                                        <vue-numeric-input
                                            placeholder="MB"
                                            v-model="maxImageSizeInBytes"
                                            controls-type="updown"
                                            :min=0
                                            :max=10000
                                            :counter="10000">
                                        </vue-numeric-input>
                                    </div>
                                </v-flex>
                                 
                                <v-flex xs12 sm6 md5>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Images per workspace limit</span>
                                    </div>
                                    <div class="standard-height white relative pl-4">
                                        <vue-numeric-input
                                        placeholder="0"
                                            v-model="maxImageItemsCount"
                                            controls-type="updown"
                                            :min=0
                                            :max=10000
                                            :counter="10000">
                                        </vue-numeric-input>
                                    </div>
                                </v-flex>

                                <v-flex xs12 sm6 md5>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Video Size Limit (MB)</span>
                                    </div>
                                    <div class="standard-height white relative pl-4">
                                        <vue-numeric-input
                                            placeholder="MB"
                                            v-model="maxVideoSizeInBytes"
                                            controls-type="updown"
                                            :min=0
                                            :max=10000
                                            :counter="10000">
                                        </vue-numeric-input>
                                    </div>
                                </v-flex>

                                 
                                <v-flex xs12 sm6 md5>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Videos per workspace limit</span>
                                    </div>
                                    <div class="standard-height white relative pl-4">
                                        <vue-numeric-input
                                        placeholder="0"
                                            v-model="maxVideoItemsCount"
                                            controls-type="updown"
                                            :min=0
                                            :max=10000
                                            :counter="10000">
                                        </vue-numeric-input>
                                    </div>
                                </v-flex>

                                <v-flex xs12 sm6 md5>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">PDF Size Limit (MB)</span>
                                    </div>
                                    <div class="standard-height white relative pl-4">
                                        <vue-numeric-input
                                            placeholder="MB"
                                            v-model="maxPdfSizeInBytes"
                                            controls-type="updown"
                                            :min=0
                                            :max=10000
                                            :counter="10000">
                                        </vue-numeric-input>
                                    </div>
                                </v-flex>

                                <v-flex xs12 sm6 md5>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">PDFs per workspace limit</span>
                                    </div>
                                    <div class="standard-height white relative pl-4">
                                        <vue-numeric-input
                                            placeholder="0"
                                            v-model="maxPdfItemsCount"
                                            controls-type="updown"
                                            :min=0
                                            :max=10000
                                            :counter="10000">
                                        </vue-numeric-input>
                                    </div>
                                </v-flex>
                                <v-flex xs12 sm6 md5>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Post-It notes per workspace</span>
                                    </div>
                                    <div class="standard-height white relative pl-4">
                                        <vue-numeric-input
                                            placeholder="0"
                                            v-model="maxPostItItemsCount"
                                            controls-type="updown"
                                            :min=0
                                            :max=10000
                                            :counter="10000">
                                        </vue-numeric-input>
                                    </div>
                                </v-flex>

                            </v-layout>
                        </div>

                        <div class="form-section mt-4 pt-2">
                            <v-layout row wrap class="pt-1">
                                <v-flex xs12>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Set default authentication method for new users</span>
                                    </div>
                                    <v-radio-group
                                        v-model="authMethod"
                                        v-validate="'required'"
                                        data-vv-name="defaultAuthNewUsers"
                                        :error-messages="errors.collect('defaultAuthNewUsers')"
                                        column
                                    >
                                        <div class="standard-height mb-1__custom white relative display-flex auth-method__checkbox">
                                            <v-radio
                                                label="Single Sign On (SSO)"
                                                color="blue"
                                                value="1"
                                            ></v-radio>
                                        </div>
                                        <div class="standard-height white relative display-flex auth-method__checkbox">
                                            <v-radio
                                                label="Local User (Username and Password)"
                                                color="blue"
                                                value="0"
                                            ></v-radio>
                                        </div>
                                    </v-radio-group>
                                </v-flex>
                                
                            </v-layout>
                        </div>

                        <div class="form-section mt-5 pt-1">
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md5>
                                    <v-btn @click="submit" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                                        <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">
                                            {{ $route.params.id ? 'Save Changes' : 'Create Company' }}
                                        </span>
                                        <v-icon right class="white--text title">
                                            {{ $route.params.id ? 'save' : 'add' }}
                                        </v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12 sm6 md5>
                                    <v-btn href="/" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                                        <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">Cancel</span>
                                    </v-btn>
                                </v-flex>
                                <v-flex v-if="companyId" xs12 sm6 md5>
                                    <v-btn v-if="userType == 1" @click="dialog = true" block large color="grey lighten-1" class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                                        <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">Delete</span>
                                        <v-icon right class="white--text title">delete</v-icon>
                                    </v-btn>
                                    <v-dialog v-model="dialog" persistent max-width="520">
                                        <div class="notification-heading standard-height blue pr-4">
                                            <v-icon @click="dialog = false" class="white body-2 blue--text notification-close mr-1">close</v-icon>
                                        </div>
                                        <v-card class="pt-4 pb-3">
                                            <v-card-title class="justify-center subtitle primary--text font-weight-bold">Do you really want to delete?</v-card-title>
                                            <v-card-actions>
                                                <v-btn class="white--text" color="grey lighten-1" grey @click="dialog = false">Cancel </v-btn>
                                                <v-spacer></v-spacer>
                                                <v-btn class="white--text" color="grey lighten-1" grey @click="submit('delete')">Confirm</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<script>
    import apiService from "../APIService"
    import company from "../services/company"
    import TopSection from '../components/TopSection.vue'
    import Header from '../components/Header.vue'
    import router from '../router'
    import VueNumericInput from 'vue-numeric-input';
    import { Sketch } from 'vue-color'
    import VeeValidate from 'vee-validate'
    import Vue from 'vue'

    const oneMbInBytes = 1048576;

  function ConvertBytesToMb(bytes){
    return Math.round(bytes/oneMbInBytes);
  }

  function ConvertMbToBytes(megaBytes){
    return megaBytes * oneMbInBytes;
  }

    let colors = {
        hex: '#194d33',
        hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
        hsv: { h: 150, s: 0.66, v: 0.30, a: 1 },
        rgba: { r: 25, g: 77, b: 51, a: 1 },
        a: 1
    }
    let color = {
        hex: '#FFFFFF'
    }
    let showColorPicker = false
    let imgPreviewSrc = {
        logo: '',
        background: ''
    }
    let filename = {
        logo: '',
        background: ''
    }
    let selectedTheme = ''

    Vue.use(VeeValidate);

    export default {
        name: 'App',
        components: {
            Header, TopSection,
            'sketch-picker': Sketch,
            'vue-numeric-input': VueNumericInput
        },
        $_veeValidate: {
            validator: 'new'
        },
        mounted() {
            this.$validator.localize('en', this.dictionary)
        },
        data() {
            return {
                progressLoad: false,
                errorDialog: false,
                deleted: false,
                dialog: false,
                companyId: this.$route.params.id,
                currentCompanyId: sessionStorage.companyId,
                userType: sessionStorage.userType,
                query: null,
                data: null,
                color,
                colors,
                items: [],
                sharingOptionsItems: ['Not currently available'],
                showColorPicker,
                filename,
                valid: true,
                name: '',
                clientTimeoutMinutes: null,
                maxImageSizeInBytes: null,
                maxVideoSizeInBytes: null,
                maxPdfSizeInBytes: null,
                maxPdfItemsCount: null,
                maxImageItemsCount: null,
                maxVideoItemsCount: null,
                maxPostItItemsCount:null,
                reader: new FileReader(),
                imgPreviewSrc,
                authMethod: '',
                success: false,
                dictionary: {
                    custom: {
                        name: {
                            required: () => 'Company name is required'
                        },
                        defaultAuthNewUsers: {
                            required: () => 'Select an authentication method for new users'
                        },
                        logoFile: {
                            image: () =>'Logo must be an image'
                        },
                        backgroundFile: {
                            image: () =>'Background must be an image'
                        }
                    }
                },
                selectedTheme,
                logoFile: '',
                backgroundFile: '',
                shouldDeleteLogo: false,
                shouldDeleteDashboardBackground: false,
            }
        },
        methods: {
            closeColerPicker() {
                this.showColorPicker = false;
            },
            async getImageSaved(imageSaved, type){
                var imageData = imageSaved.split('/');
                if(imageData[imageData.length - 1] != ''){
                    this.image = await company.getImage(this.companyId, imageData[imageData.length - 1])
                    this.imagine = URL.createObjectURL(this.image.data);
                    this.imgPreviewSrc[type] = this.imagine;
                    this.filename[type] = imageData[imageData.length - 1];
                }
                
            },
            handleFileSelection(event, type, field) {
                this.$validator.validate(field).then(result => {
                    if (result) {
                        this.filename[type] = event.target.files[0].name
                        if (type == 'logo') {
                            this.logoFile = event.target.files[0];
                            this.shouldDeleteLogo = false;
                        } else {
                            this.backgroundFile = event.target.files[0];
                            this.shouldDeleteDashboardBackground = false;
                        }
                        let reader = new FileReader();
                        reader.onload = (e) => {
                            this.imgPreviewSrc[type] = e.target.result
                        }
                        reader.readAsDataURL(event.target.files[0]);
                    }
                });
            },
            uploadFile(type) {
                document.getElementById('image-' + type).click();
            },
            handleRemoveFile(type) {
                if(type == 'logo') {
                    this.shouldDeleteLogo = true;
                } else {
                    this.shouldDeleteDashboardBackground = true;
                }
                this.$refs[type].value = '';
                this.imgPreviewSrc[type] = '';
                this.filename[type] = null;
            },
            homeRedirect() {
                router.push('/')
            },
            async submit(event) {
                this.$validator.validate().then(result => {
                    if (result) {
                        // this.progressLoad = true;
                        if (this.companyId) {
                            if(event == 'delete') {
                                this.dialog = false;
                                const updateData = company.delete(this.companyId).then(res => {
                                    this.progressLoad = false;
                                    if (res.data.status == 1) {
                                        this.success = true;
                                        this.deleted = true;
                                    }
                                }).catch(err => {
                                    this.progressLoad = false;
                                    this.dialog = false;
                                    this.errorDialog = true;
                                });
                            } else {
                                var dataUpdate = new FormData();
                                if (this.name != this.data.data.name) {
                                    dataUpdate.append('name',  this.name);
                                }
                                dataUpdate.append('logo', this.logoFile); 
                                dataUpdate.append('ShouldDeleteLogo', this.shouldDeleteLogo);
                                dataUpdate.append('dashboardBackground', this.backgroundFile);
                                dataUpdate.append('ShouldDeleteDashboardBackground', this.shouldDeleteDashboardBackground);
                                dataUpdate.append('accentColor', this.color.hex); 
                                dataUpdate.append('theme', this.selectedTheme);
                                dataUpdate.append('clientTimeoutMinutes', this.clientTimeoutMinutes);
                                dataUpdate.append('maxImageSizeInBytes',  ConvertMbToBytes(this.maxImageSizeInBytes));
                                dataUpdate.append('maxVideoSizeInBytes', ConvertMbToBytes(this.maxVideoSizeInBytes));
                                dataUpdate.append('maxPdfSizeInBytes',  ConvertMbToBytes(this.maxPdfSizeInBytes));
                                dataUpdate.append('maxPdfItemsCount', this.maxPdfItemsCount);
                                dataUpdate.append('maxImageItemsCount', this.maxImageItemsCount);
                                dataUpdate.append('maxVideoItemsCount', this.maxVideoItemsCount);
                                dataUpdate.append('maxPostItItemsCount', this.maxPostItItemsCount);
                                dataUpdate.append('shouldSetClientTimeout', true);
                                dataUpdate.append('defaultAuthNewUsers', parseFloat(this.authMethod));
                                const updateData = company.updateCompanyById(this.companyId, dataUpdate).then(res => {
                                    this.progressLoad = false;
                                    if (res.data.status == 1) {
                                        this.success = true;
                                    }
                                }).catch(err => {
                                    this.progressLoad = false;
                                    this.errorDialog = true;
                                });
                            }
                        } else {
                            var dataCreate = new FormData();
                            dataCreate.append('name', this.name);
                            dataCreate.append('logo', this.logoFile);
                            dataCreate.append('dashboardBackground', this.backgroundFile);
                            dataCreate.append('accentColor', this.color.hex);
                            dataCreate.append('theme', this.selectedTheme);
                            dataCreate.append('clientTimeoutMinutes', this.clientTimeoutMinutes);
                            dataCreate.append('maxImageSizeInBytes', ConvertMbToBytes(this.maxImageSizeInBytes));
                            dataCreate.append('maxVideoSizeInBytes', ConvertMbToBytes(this.maxVideoSizeInBytes));
                            dataCreate.append('maxPdfSizeInBytes', ConvertMbToBytes(this.maxPdfSizeInBytes));
                            dataCreate.append('maxPdfItemsCount', this.maxPdfItemsCount);
                            dataCreate.append('maxImageItemsCount', this.maxImageItemsCount);
                            dataCreate.append('maxVideoItemsCount', this.maxVideoItemsCount);
                            dataCreate.append('maxVideoItemsCount', this.maxVideoItemsCount);
                            dataCreate.append('maxPostItItemsCount', this.maxPostItItemsCount);


                            const createData = company.create(dataCreate).then(res => {
                                this.progressLoad = false;
                                if (res.data.status == 1) {
                                    this.success = true;
                                }
                            }).catch(err => {
                                this.progressLoad = false;
                                this.errorDialog = true;
                            });
                        }
                    }
                });
            },
            async fetchData() {
                if (this.companyId) {
                    this.data = await company.fetchCompanyById(this.companyId);
                    this.name = this.data.data.name
                    this.authMethod = this.data.data.defaultAuthNewUsers.toString()
                    this.selectedTheme = this.data.data.theme;
                    this.color.hex = this.data.data.accentColor;
                    this.getImageSaved(this.data.data.dashboardBackground, 'background');
                    this.getImageSaved(this.data.data.logo, 'logo');
                    this.clientTimeoutMinutes = this.data.data.clientTimeoutMinutes

                    // Size and items count limits:
                    this.maxImageSizeInBytes = ConvertBytesToMb(this.data.data.maxImageSizeInBytes);
                    this.maxPdfSizeInBytes = ConvertBytesToMb(this.data.data.maxPdfSizeInBytes);
                    this.maxVideoSizeInBytes = ConvertBytesToMb(this.data.data.maxVideoSizeInBytes);
                    this.maxImageItemsCount = this.data.data.maxImageItemsCount;
                    this.maxPdfItemsCount = this.data.data.maxPdfItemsCount;
                    this.maxVideoItemsCount = this.data.data.maxVideoItemsCount;
                    this.maxPostItItemsCount = this.data.data.maxPostItItemsCount;
                }
                this.items = await company.getThemes();
                this.items = this.items.data;
            }
        },
        created() {
            this.fetchData();
        }
    }
</script>

<style lang="scss">
    .image-preview-wrapper {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        z-index: -1;
        background-size: cover;
        background-position: 50% 50%;
    }

    .image-preview {
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .color-selector {
        line-height: 52px;
        .color-preview

    {
        float: right;
    }

    }

    .file-uploader {
        border: 1px solid #707070;
        height: 165px;
        position: relative;
        margin: 0 auto;
        background-color: #EEEEEE;
        &.uploaded

    {
        .image-preview-wrapper

    {
        z-index: 1;
    }

    }

    input {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        display: block;
        opacity: 0;
        width: 100%;
    }

    &.logo {
        max-width: 165px;
    }

    &.background {
        width: 75%;
    }

    .subheading {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        pointer-events: none;
    }

    .vue_component__upload--image {
        height: 100%;
        padding: 0;
    }

    #upload_image_form--default {
        height: 100%;
    }

    .upload_image_form__thumbnails {
        height: 100%;
    }

    .upload_image_form__thumbnail {
        width: 100% !important;
        height: 100%;
        margin: 0 !important;
        z-index: 1;
    }

    .vue_component__upload--image .upload_image_form__thumbnail img {
        filter: unset !important;
    }

    .vue_component__upload--image .upload_image_form__thumbnail span {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        color: #FFFFFF;
        top: 0;
    }

    .vue_component__upload--image form > div {
        button

    {
        width: 66px;
        height: 66px;
        outline: none;
    }

    }
    }

    .color-range {
        bottom: 0;
        left: 0;
        right: 0;
        position: absolute;
        .vc-sketch

    {
        width: 100%;
        box-shadow: none;
        -webkit-box-shadow: none;
        -webkit-box-shadow: none;
        box-sizing: border-box;
    }

    }

    .color-preview {
        width: 50px;
        height: 50px;
        display: inline-block;
        border: 1px solid #373B47;
    }

</style>


